export const ModeStates = Object.freeze({
  EDIT: 'EDIT',
  PREVIEW: 'PREVIEW',
  VIEW: 'VIEW',
});

export const SaveStates = Object.freeze({
  IDLE: 'IDLE',
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERRORED: 'ERRORED',
});

export const VIZ_PANE_CSS_ANIMATION_DELAY = 100;
